module.exports = __webpack_public_path__ + "img/arrow-up.f3a7ac48.svg";